export const SAVE_ALL_TAXES = 'SAVE_ALL_TAXES'